import { render, staticRenderFns } from "./DrayageListResponsive.vue?vue&type=template&id=67bc5ace&scoped=true"
import script from "./DrayageListResponsive.vue?vue&type=script&lang=js"
export * from "./DrayageListResponsive.vue?vue&type=script&lang=js"
import style0 from "./DrayageListResponsive.vue?vue&type=style&index=0&id=67bc5ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc5ace",
  null
  
)

export default component.exports